var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgJson = function SvgJson(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 5c-.398 0-.78.246-1.06.683-.282.438-.44 1.031-.44 1.65v2.334c0 .619-.158 1.212-.44 1.65-.28.437-.662.683-1.06.683.398 0 .78.246 1.06.683.282.438.44 1.031.44 1.65v2.334c0 .618.158 1.212.44 1.65.28.437.662.683 1.06.683M16 19c.398 0 .78-.246 1.06-.683.282-.438.44-1.032.44-1.65v-2.334c0-.619.158-1.212.44-1.65.28-.437.662-.683 1.06-.683-.398 0-.78-.246-1.06-.683-.282-.438-.44-1.031-.44-1.65V7.333c0-.619-.158-1.212-.44-1.65C16.78 5.246 16.399 5 16 5",
    className: "icon-stroke-width"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJson);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;